export default "__VITE_ASSET__D_B3JJQQ__"